import React from 'react';
import PropTypes from 'prop-types';

const AnimatedHeart = ({ className, innerRef }) => (
  <svg
    width="140px"
    height="130px"
    viewBox="0 0 141 130"
    version="1.1"
    className={className}
    ref={innerRef}
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        transform="translate(-119.000000, -263.000000)"
        fill="#e34242"
        fillRule="nonzero"
      >
        <g id="heart-shape" transform="translate(119.047588, 202.001002)">
          <g id="Group-3" transform="translate(0.000000, 8.038423)">
            <g id="Group-9" transform="translate(0.000000, 52.961577)">
              <path
                d="M70.0156827,12.6138908 C77.6931115,4.52090553 88.0416158,0 98.9431095,0 C105.883293,0 112.756768,1.87285776 118.831919,5.41982086 C131.899472,13.1068309 140,27.6468516 140,43.3472531 C140,47.7959604 139.334292,52.2207599 138.107325,56.1730664 C135.127362,69.922797 123.103973,85.8909008 103.312161,103.533434 C96.7977705,109.340397 89.7156621,115.076194 82.3065067,120.587258 L79.4932498,122.657987 C76.7561437,124.650939 74.2728652,126.393753 72.2717859,127.735153 L70.0245592,129.241555 L66.7374572,127.034328 L64.4406792,125.444106 C63.2259557,124.591394 61.9183298,123.65666 60.5474945,122.659601 L57.7303424,120.588219 C50.3134965,115.077195 43.2241175,109.341196 36.7034447,103.534026 C16.9502328,85.9422426 4.87051793,69.9670225 2.05543013,56.8221446 C0.672802722,52.2590962 2.38341681e-13,47.8389799 2.38341681e-13,43.3472531 C2.38341681e-13,27.6191899 8.10173458,13.0776773 21.1866864,5.40869264 C27.269988,1.8724236 34.1331063,0 41.0329782,0 C51.9302265,0 62.299258,4.52182922 70.0156827,12.6138908 Z"
                id="Shape"
              />
              <path
                d="M70.0218222,119.490059 L72.8030418,117.526641 C73.2926837,117.176056 73.7942498,116.814544 74.3060457,116.443223 L77.486031,114.10654 C84.7100369,108.733193 91.6077142,103.146768 97.9376736,97.5042067 C116.562365,80.902052 127.684835,66.1304474 130.299502,54.1336503 C131.377433,50.6186156 131.923077,46.9918574 131.923077,43.3472531 C131.923077,30.475165 125.306921,18.5995145 114.748104,12.3882472 C109.915983,9.56704404 104.44717,8.07692308 98.9431095,8.07692308 C90.2753648,8.07692308 82.0396134,11.6748396 75.8753892,18.1727149 L70.0308425,24.3336101 L64.1703768,18.1878555 C57.9650217,11.6804227 49.7018166,8.07692308 41.0329782,8.07692308 C35.5676452,8.07692308 30.1036887,9.56762175 25.2583072,12.3842487 C14.6916245,18.5773202 8.07692308,30.4498105 8.07692308,43.3472531 C8.07692308,47.0344151 8.62975303,50.6663456 9.86842322,54.8013469 C12.3151961,66.1700378 23.4952316,80.9554469 42.0751505,97.5023205 C48.4112302,103.145096 55.3160252,108.73175 62.5475755,114.105091 L67.2370246,117.526234 L70.0218222,119.490059 Z"
                id="Path"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

AnimatedHeart.propTypes = {
  className: PropTypes.string,
  innerRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.elementType })
  ])
};

AnimatedHeart.defaultProps = {
  className: '',
  innerRef: () => {}
};

export default AnimatedHeart;
